module.exports = __webpack_public_path__ + "img/cpu-chip-01.c39eddb8.svg";